import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useLocalizedLanguageLinks } from 'LoginUI/hooks/useLocalizedLanguageLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MarketingCta = () => {
  const {
    demoLink,
    buyLink
  } = useLocalizedLanguageLinks();
  return /*#__PURE__*/_jsxs(Flex, {
    marginBlockEnd: "-1000",
    marginBlockStart: "400",
    justifySelf: "center",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(View, {
      maxInlineSize: "400px",
      children: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.marketingCopy.upgradeAccount"
        })
      })
    }), /*#__PURE__*/_jsxs(ButtonWrapper, {
      marginBlockStart: "300",
      justify: "center",
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "demo-button",
        href: demoLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.marketingCopy.getDemo"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "buy-button",
        href: buyLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.marketingCopy.buyStarter"
        })
      })]
    })]
  });
};
export default MarketingCta;